import React from 'react';
import siteContent from '../../content/site/content.json';
import { Quote } from 'lucide-react';

const QuoteStrip = () => {
  const d = siteContent.pilotQuotes;
  const quotes = d?.quotes || [];
  const [active, setActive] = React.useState(0);

  React.useEffect(() => {
    if (quotes.length < 2) return;
    const t = setInterval(() => setActive((p) => (p + 1) % quotes.length), 7000);
    return () => clearInterval(t);
  }, [quotes.length]);

  if (!d || !d.enabled || quotes.length === 0) return null;

  return (
    <section className="py-16 sm:py-20 bg-white" data-testid="pilot-quotes">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {d.heading && (
          <h2 className="text-base md:text-lg font-bold text-[#B5541B] uppercase tracking-wide mb-8" data-testid="pilot-quotes-heading">
            {d.heading}
          </h2>
        )}
        <div className="relative min-h-[180px] sm:min-h-[150px]">
          {quotes.map((q, i) => (
            <figure
              key={i}
              data-testid={`pilot-quote-${i}`}
              className={`absolute inset-0 transition-opacity duration-700 ${i === active ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
              aria-hidden={i !== active}
            >
              <Quote className="w-8 h-8 text-[#B5541B]/30 mx-auto mb-4" aria-hidden="true" />
              <blockquote className="text-lg sm:text-xl font-medium text-[#1F1E1E] leading-relaxed">
                “{q.text}”
              </blockquote>
              <figcaption className="mt-4 text-sm text-[#6B6560]">
                <span className="font-semibold text-[#1F1E1E]">{q.name}</span>
                {q.role && <span> — {q.role}</span>}
              </figcaption>
            </figure>
          ))}
        </div>
        {quotes.length > 1 && (
          <div className="flex justify-center gap-2 mt-6">
            {quotes.map((_, i) => (
              <button
                key={i}
                onClick={() => setActive(i)}
                data-testid={`pilot-quote-dot-${i}`}
                aria-label={`Show quote ${i + 1}`}
                className={`w-2 h-2 rounded-full transition-colors ${i === active ? 'bg-[#B5541B]' : 'bg-[#1F1E1E]/20 hover:bg-[#1F1E1E]/40'}`}
              />
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default QuoteStrip;
